module.exports = __webpack_public_path__ + "img/outlander-es-red-compressor.f39ff8b0.png";